import AddToCart from './component.vue'

export default AddToCart
